export enum SignInSignUpOption {
  Phone,
  Email,
}
